import PropTypes from 'prop-types'
import { PopupAction } from '../../../../common/popup/PopupAction'

export const DeletePortfolio = ({
  isShow,
  setShow,
  renderContent,
  handleDelete,
}) => {
  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title="library.savePortfolio.DELETE_PORTFOLIO"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.main.DELETE',
            event: (e) => {
              e.stopPropagation()
              handleDelete()
            },
            isI18n: true,
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
            isI18n: true,
          }}
        >
          <>{renderContent && renderContent()}</>
        </PopupAction>
      )}
    </>
  )
}
DeletePortfolio.propTypes = {
  renderContent: PropTypes.func,
  isShow: PropTypes.bool,
  setShow: PropTypes.func,
  handleDelete: PropTypes.func,
}
